import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AulaResponse, AulaRequest } from "app/shared/models/ei-models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { BaseService } from "../../core";

@Injectable({
  providedIn: 'root'
})
export class AulaService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Aula/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  obterPorId(id: number): Observable<AulaResponse> {
    return this.httpClient.get<AulaResponse>(
      this.controllerEndpoint.concat('ObterPorId/', id.toString()),
      { headers: this.getHeader(true) }
    );
  }
  
  listarPorModulo(moduloId: number): Observable<AulaResponse[]> {
    return this.httpClient.get<AulaResponse[]>(
      this.controllerEndpoint.concat('ListarPorModulo/', moduloId.toString()),
      { headers: this.getHeader(true) }
    );
  }

  listarTodas(filtro: any): Observable<AulaResponse[]> {
    return this.httpClient.get<AulaResponse[]>(
      this.controllerEndpoint.concat('ListarTodas'),
      { 
        headers: this.getHeader(true),
        params: { 
          ...(filtro.trilhaId && { trilhaId: filtro.trilhaId.toString() }),
          ...(filtro.moduloId && { moduloId: filtro.moduloId.toString() })
        }
      }
    );
  }

  criar(request: AulaRequest): Observable<void> {
    return this.httpClient.post<void>(
      this.controllerEndpoint.concat('Criar'),
      request,
      { headers: this.getHeader(true) }
    );
  }

  atualizar(payload: AulaRequest): Observable<void> {
    return this.httpClient.put<void>(
      this.controllerEndpoint.concat('Atualizar/', payload.id.toString()),
      payload,
      { headers: this.getHeader(true) }
    );
  }

  remover(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      this.controllerEndpoint.concat('Remover/', id.toString()),
      { headers: this.getHeader(true) }
    );
  }
}